module.exports = __webpack_public_path__ + "img/chipping3.b4f10042.png";